import { render, staticRenderFns } from "./gnosisAddressCandidates.vue?vue&type=template&id=d5363918&"
import script from "./gnosisAddressCandidates.vue?vue&type=script&lang=js&"
export * from "./gnosisAddressCandidates.vue?vue&type=script&lang=js&"
import style0 from "./gnosisAddressCandidates.vue?vue&type=style&index=0&id=d5363918&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports